import {
  GET_MASTER_TAGS,
} from 'constants/masterTags';

export default (state = [], action) => {
    switch (action.type) {
    case `${GET_MASTER_TAGS}_SUCCESS`:
      return action.payload;
    default:
      return state;
  }
};
